import { render, staticRenderFns } from "./NoFound.vue?vue&type=template&id=b3c7e650&scoped=true"
import script from "./NoFound.vue?vue&type=script&lang=js"
export * from "./NoFound.vue?vue&type=script&lang=js"
import style0 from "./NoFound.vue?vue&type=style&index=0&id=b3c7e650&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c7e650",
  null
  
)

export default component.exports